import React from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import StarterPanel from '../../components/Dashboard/StarterPanel';
import MetricSection from '../../components/Dashboard/MetricSection';
import StudentPopulationGraph from '../../components/Dashboard/StudentPopulationGraph';
import RenderSecure from '../../util/RenderSecure';


const DashboardPage = () => {


    return (
        <PageContainer>
            <MainContent>
                <PageTitle
                    title="Dashboard"
                    description="Basic overview of the school dashboard"
                    iconClass="fa fa-home"
                />

                 <div className="row mb-2 small-gutters">
                    {/* Left Side: Title and Buttons */}
                    <StarterPanel/>

                    {/* Right Side: 4 Metric Cards */}
                     <RenderSecure code={['STUDENT_POPULATION', 'STAFF_POPULATION', 'SUBJECT_COUNT']}>
                        <div className="col-lg-5">
                            <MetricSection />
                        </div>
                     </RenderSecure>
                   
                    <RenderSecure code="STUDENT_POPULATION">
                        <div className="col-lg-3">
                            <StudentPopulationGraph />
                        </div>
                    </RenderSecure>
                    
                  </div>

               
            </MainContent>
        </PageContainer>
    );
};

export default DashboardPage;
